/* Product enquiry modal
 * - opens the shared #nk-enquire-modal
 * - copies the clicked button's product data into the hidden contact[...] fields
 * - upgrades the legacy "Make An Enquiry" custom-liquid link (which used to
 *   redirect to /pages/contact-us) into a modal trigger
 * No dependencies - deliberately plain JS so it does not wait on jQuery.
 */
(function () {
  'use strict';

  var modal = document.getElementById('nk-enquire-modal');
  if (!modal) return;

  var lastFocus = null;
  var summary = modal.querySelector('[data-nk-enquire-summary]');

  // Fallback for browsers without :has() - the css above already hides the
  // legacy custom-liquid button when a themed enquiry button is on the page.
  if (document.querySelector('.product-converter__blocks .nk-enquire-btn')) {
    var legacyBoxes = document.querySelectorAll('.product-converter__blocks .custom_button_container');
    for (var i = 0; i < legacyBoxes.length; i++) legacyBoxes[i].style.display = 'none';
  }

  function field(name) {
    return modal.querySelector('[data-nk-field="' + name + '"]');
  }

  function setField(name, value) {
    var el = field(name);
    if (el) el.value = value || '';
  }

  function open(trigger) {
    lastFocus = trigger || document.activeElement;

    if (trigger) {
      var d = trigger.dataset;
      setField('title', d.productTitle);
      setField('sku', d.productSku);
      setField('url', d.productUrl);
      setField('variant', d.variantTitle);
      setField('price', d.productPrice);

      if (summary) {
        var bits = [];
        if (d.productTitle) bits.push(d.productTitle);
        if (d.productSku) bits.push('SKU: ' + d.productSku);
        if (d.productPrice) bits.push(d.productPrice);
        summary.textContent = bits.join('  |  ');
        summary.hidden = bits.length === 0;
      }
    }

    modal.hidden = false;
    document.documentElement.classList.add('nk-enquire-open');

    var first = modal.querySelector('input:not([type="hidden"]), textarea');
    if (first) first.focus();
  }

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('nk-enquire-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nk-enquire]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    // legacy custom-liquid button: an <a> to the contact page inside .custom_button_container
    var legacy = e.target.closest('.custom_button_container a, a.custom_button');
    if (legacy && /\/pages\/contact/i.test(legacy.getAttribute('href') || '')) {
      e.preventDefault();
      open(legacy.hasAttribute('data-product-title') ? legacy : nearestProductTrigger(legacy));
      return;
    }

    if (e.target.closest('[data-nk-enquire-close]')) {
      e.preventDefault();
      close();
    }
  });

  // the legacy link carries no product data - borrow it from any enquiry button
  // on the page, or fall back to the current URL.
  function nearestProductTrigger(el) {
    var btn = document.querySelector('[data-nk-enquire]');
    if (btn) return btn;
    return {
      dataset: {
        productTitle: (document.querySelector('h1') || {}).textContent || document.title,
        productUrl: window.location.href,
        productSku: '',
        variantTitle: '',
        productPrice: ''
      }
    };
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Shopify redirects back with ?contact_posted=true - reopen so the sender
  // actually sees the confirmation instead of a silently reloaded page.
  if (modal.querySelector('[data-nk-enquire-success]') ||
      /contact_posted=true/.test(window.location.search)) {
    open(null);
  }
})();
